<template>
  <div class="content">
    <div class="box">
      <div class="title">
        <p>{{ name }}</p>
      </div>
      <div :style="{ marginTop: isShow('4') ? '0px' : '-30px'}">
        <Youjifeiyong v-if="isShow(1)"/>
        <Youjicailiao v-if="isShow(2)"/>
        <Yizhanshi v-if="isShow(3)"/>
        <Apec v-if="isShow(4)"/>
      </div>
    </div>
  </div>
</template>

<script>
import Youjicailiao from './youjicailiao'
import Youjifeiyong from './youjifeiyong'
import Yizhanshi from './yizhanshi'
import Apec from './apec'
export default {
  name: 'middle-content',
  components: {
    Youjicailiao,
    Youjifeiyong,
    Yizhanshi,
    Apec
  },
  data () {
    return {
      name: '',
      htmlContent: '',
    }
  },
  created () {
    this.name = this.$route.query.name
  },
  methods: {
    isShow (type) {
      return this.$route.query.type == type
    }
  }
}
</script>

<style scoped lang='less'>
.content {
  width: 100%;
  position: relative;
  margin-bottom: 50px;
}
.content .box {
  width: 1140px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background:#FFF;
}
.title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 41px;
  text-align: left;
  margin-top: 30px;
  & > p {
    display: inline-block;
    padding-bottom: 5px;
    border-bottom:  2px solid #CBB486;
    margin-bottom: 0;
  }
}
.li-box {
  display: flex;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #EEEEEE;
  cursor: pointer;
  & > div:nth-of-type(1) {
    /* flex: 1; */
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3D4652;
    line-height: 80px;
    &:hover {
      color: #CBB486;
    }
  }
  & > div:nth-of-type(1)::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #CBB486;
    margin-right: 10px;
    transform: translateY(-2px);
  }
  & > div:nth-of-type(2) {
    flex: 100px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #BCBEC0;
    text-align: right;
    line-height: 80px;
  }
}
/deep/ .ant-pagination-item-active {
  border: none;
  background: #CBB486;
}
/deep/ .ant-pagination-item-active a {
  color: white;
}
/deep/ .ant-pagination-item:hover {
  background: #CBB486;
  border: none;
  color: white;
}
/deep/ .ant-pagination-item:hover a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/selfComponents/siderContent-01.vue